export default {
  countries: [],
  states: [],
};
